/**
 * API functions for CSV export (Reportes BO).
 * Alineado con GET /api/v1/bo/exports/csv — HU-77A-BE / HU-77B-BE.
 *
 * @taskId T653
 * @see functional/Cycles/cycle-5/tasks.md HU-29-FE
 */

import { authFetch, normalizeApiError } from '@flexibilitypay/shared';

export type ReportType = 'TRANSACTIONS' | 'ACCOUNTS' | 'CUSTOMERS';

export interface ExportCsvParams {
  type: ReportType;
  from: string; // ISO date: YYYY-MM-DD
  to: string;   // ISO date: YYYY-MM-DD
}

const BASE_PATH = '/api/v1/bo/exports/csv';

/**
 * GET /api/v1/bo/exports/csv — Descarga CSV en streaming.
 * Retorna el Blob con el contenido del archivo.
 */
export async function exportCsv(params: ExportCsvParams): Promise<Blob> {
  const searchParams = new URLSearchParams({
    type: params.type,
    from: params.from,
    to: params.to,
  });

  const res = await authFetch(`${BASE_PATH}?${searchParams.toString()}`);
  if (!res.ok) throw await normalizeApiError(res);
  return res.blob();
}
